import React from 'react';
// import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
// import LoadingScreen from '../components/Complements/LoadingScreen';
import PrincipalPanel from '../components/Logout/PrincipalPanel';
//import Login from '../components/Logout/PrincipalPanel';
import { backgroundStyles } from '../styles/LoginTheme';
import { isMobile } from 'react-device-detect';
import { history } from '../helpers/history';
import { sendMobile } from './../functions/mobile';

//const useStyles = makeStyles(theme => ({
    /* fondo: {
        [theme.breakpoints.up('xs')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('md')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('lg')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        [theme.breakpoints.up('xl')]: {
            backgroundColor: "#EEEFF2",
            width : "100%",
            height : "100%"
        },
        
    }, */
    
//}))

const handleFingerPrint = () => {
    let send = {
        type: 'action',
        action: 'openFinguerPrint',
        data: true
    }
    sendMobile(JSON.stringify(send))

};

const HomeLogoutContainer = props => {
    // const [ loading, setLoading ] = useState(false);
    const classes = backgroundStyles();

    return (
        <div className = { classes.fondo }>
            {/* <LoadingScreen 
                open={loading} 
            /> */}
            {
                isMobile ?
                <PrincipalPanel
                // onSubmit = { handleSubmit } 
                finguerprint = { handleFingerPrint }
            />
                :
                history.push('/login')
            }
            
        </div>
    );
};

HomeLogoutContainer.propTypes = {
    
};

export default HomeLogoutContainer;